import React, { useState } from "react";

const AdvanceEstimator = () => {
  const [invoiceAmount, setInvoiceAmount] = useState("120000");
  const [creditTier, setCreditTier] = useState("A");
  const [tenor, setTenor] = useState("30");
  const [results, setResults] = useState({
    advanceRate: "80%",
    cashToday: "PKR 96,000",
    estimatedFee: "PKR 1,400",
    effectiveMonthly: "1.17%",
  });

  const formatPKR = (amount) => {
    return "PKR " + Math.round(amount).toLocaleString("en-PK");
  };

  const calculate = () => {
    const invoice = parseFloat(invoiceAmount.replace(/,/g, "")) || 0;
    const tenorDays = parseInt(tenor);
    const annualRate = 0.14;
    const monthlyRate = annualRate / 12;

    const cashToday = invoice * 0.8;
    const fee = invoice * monthlyRate * (tenorDays / 30);
    const effectiveMonthly = monthlyRate * 100;

    setResults({
      advanceRate: "80%",
      cashToday: formatPKR(cashToday),
      estimatedFee: formatPKR(fee),
      effectiveMonthly: effectiveMonthly.toFixed(2) + "%",
    });
  };

  return (
    <section className="w-full bg-[#D7F3EF] py-20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">

          {/* Left Card */}
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <h3 className="text-xl font-semibold text-[#1E293B] mb-6">
              Estimate your advance
            </h3>

            <div className="space-y-4">
              <div>
                <label className="block text-sm text-[#64748B] mb-1">
                  Invoice amount (PKR)
                </label>
                <input
                  type="number"
                  value={invoiceAmount}
                  onChange={(e) => setInvoiceAmount(e.target.value)}
                  className="w-full border border-[#E2E8F0] rounded-lg px-4 py-3 text-[#0F172A] bg-white"
                  placeholder="Enter amount"
                />
              </div>

              <div>
                <label className="block text-sm text-[#64748B] mb-1">
                  Buyer credit tier
                </label>
                 <input
                  type="text"
                  value="(low risk)"
            
                  className="w-full border border-[#E2E8F0] rounded-lg px-4 py-3 text-[#0F172A] bg-white"
                  placeholder="(low risk)"
                />
                {/* <select
                  value={creditTier}
                  onChange={(e) => setCreditTier(e.target.value)}
                  className="w-full border border-[#E2E8F0] rounded-lg px-4 py-3 text-[#0F172A] bg-white"
                >
                  <option value="A">A (low risk)</option>
                  <option value="B">B (medium risk)</option>
                  <option value="C">C (high risk)</option>
                </select> */}
              </div>

              <div>
                <label className="block text-sm text-[#64748B] mb-1">
                  Tenor (days)
                </label>
                <select
                  value={tenor}
                  onChange={(e) => setTenor(e.target.value)}
                  className="w-full border border-[#E2E8F0] rounded-lg px-4 py-3 text-[#0F172A] bg-white"
                >
                  <option value="30">30 days</option>
                  <option value="60">60 days</option>
                  <option value="90">90 days</option>
                </select>
              </div>

              <button
                onClick={calculate}
                className="mt-6 w-full bg-[#0F766E] hover:bg-[#115E59] text-white font-semibold py-3 rounded-lg transition"
              >
                Recalculate
              </button>
            </div>
          </div>

          {/* Right Card */}
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <h3 className="text-xl font-semibold text-[#1E293B] mb-6">
              Projected results
            </h3>

            <div className="space-y-5">
              <ResultRow label="Advance rate" value={results.advanceRate} />
              <ResultRow label="Cash today" value={results.cashToday} bold />
              <ResultRow label="Estimated fee" value={results.estimatedFee} />
              <ResultRow label="Annual cost" value="14%" />
              <ResultRow label="Effective monthly cost" value={results.effectiveMonthly} />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

const ResultRow = ({ label, value, bold }) => {
  return (
    <div className="flex justify-between items-center border-b border-[#E2E8F0] pb-3">
      <span className="text-sm text-[#64748B]">{label}</span>
      <span className={`text-[#0F172A] ${bold ? "text-lg font-semibold" : "font-medium"}`}>
        {value}
      </span>
    </div>
  );
};

export default AdvanceEstimator;